import React, { useCallback } from 'react';
import { Box, RadioButton, Text } from '@common-fe/common-fe';

import ReportDateRange from '../../ReportDateRange';

interface Props {
  disabled?: boolean;
  startDate: Date | null;
  isContributionMode: boolean;
  onChangeContributionMode: (value: boolean) => void;
  endDate: Date | null;
  onSetStartDate: (value: Date | null) => void;
  onSetEndDate: (value: Date | null) => void;
}
const PayrollContributionRange: React.FC<Props> = ({
  disabled,
  startDate,
  endDate,
  onSetEndDate,
  onSetStartDate,
  onChangeContributionMode,
  isContributionMode,
}) => {
  const handleChangeValues = useCallback(
    (value: [Date | null, Date | null]) => {
      if (value[0] === null) {
        onSetStartDate(null);
        onSetEndDate(null);
      } else {
        onSetStartDate(value[0]);
        onSetEndDate(value[1]);
      }
    },
    [onSetEndDate, onSetStartDate]
  );
  return (
    <ReportDateRange
      values={[startDate, endDate]}
      disabled={disabled}
      onChangeValues={handleChangeValues}
      prefix={isContributionMode ? 'Contribution date range' : 'Transaction date range'}
      preRangeNode={(
        <Box>
          <Box
            border={{ side: 'bottom', size: 'small', color: 'border1' }}
            pad={{ horizontal: 'spacing12', vertical: 'spacing12' }}
          >
            <Text size="medium" weight={700} margin={{ bottom: 'spacing8' }}>
              Date range for:
            </Text>
            <Box margin={{ bottom: 'spacing8' }}>
              <RadioButton
                name="isContributionMode"
                onChange={() => {
                  onChangeContributionMode(true);
                }}
                label={<Text>Contribution Date</Text>}
                checked={isContributionMode}
              />
            </Box>
            <RadioButton
              name="isContributionMode"
              onChange={() => {
                onChangeContributionMode(false);
              }}
              label={<Text>Transaction Date</Text>}
              checked={!isContributionMode}
            />
          </Box>

          <Box margin={{ bottom: '-12px' }} pad={{ horizontal: 'spacing12' }}>
            <Text size="medium" margin={{ top: 'spacing8' }} weight={700}>
              Preselected range
            </Text>
          </Box>
        </Box>
      )}
    />
  );
};

export default PayrollContributionRange;
